
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import DeclinedReason from "@/views/payments/paymentRequestReports/DeclinedReason.vue";
import PaymentTransaction from "@/views/PaymentTransaction.vue";
import OtpVerification from "@/components/portal/client/services/moneyTransfer/otpverification.vue";
import DmtConfirmation from "@/components/portal/client/services/moneyTransfer/confirmationPopup.vue";
import DmtSuccessful from "@/components/portal/client/services/moneyTransfer/successfulPopup.vue";
import UpdateParentUser from "@/components/portal/client/configuration/users/userList/updateParent/UpdateParent.vue";
import AepsPopup from "@/components/portal/client/services/AEPS/AepsPopup.vue";
import RechargePlan from "@/components/portal/client/services/recharge/RechargeOffer.vue";

@Component({
  components: {
    DeclinedReason,
    PaymentTransaction,
    OtpVerification,
    DmtConfirmation,
    DmtSuccessful,
    UpdateParentUser,
    AepsPopup,
    RechargePlan
  },
})
export default class ModalComponent extends Vue {
  @Prop() data: any;
  @Prop() title: string;
  @Prop() component: string;
  @Prop() show: boolean;

  Close() {
    this.$emit("closeModal", false);
  }
  updateDeclinedReason() {
    this.$emit("updateDeclinedReason", true);
  }
  updatePaymentTransaction() {
    this.$emit("updatePaymentTransaction", true);
  }
  updateOTPVerification(value) {
    this.$emit("updateOTPVerification", value);
  }
  updateDmtConfirmation(value) {
    this.$emit("updateDmtConfirmation", value);
  }
  updateDmtSuccessful(value) {
    this.$emit("updateDmtSuccessful", value);
  }
  updateParentUser(value) {
    this.$emit("updateParentUser", value);
  }

  aepsWithdrawBalance(value) {
    this.$emit("aepsWithdrawBalance", value);
  }

  rechargeOfferAmount(value){
    this.$emit("rechargeOfferAmount", value);
  }

  @Watch("show")
  onShowValueChange(value) {
    let body = document.getElementsByTagName("body")[0];
    body.classList.add("modal_padding0");
    let header = document.getElementsByTagName("header")[0];
    if (value) {
      header.classList.add("sticky-top0");
      header.classList.remove("sticky-top");
    } else {
      header.classList.remove("sticky-top0");
      header.classList.add("sticky-top");
    }
  }
}
